import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { OrderService } from "../../../service/order.service";
import { InvoiceService } from "../../../service/invoice.service";
import { HttpErrorResponse } from "@angular/common/http";
import { Message } from "primeng/components/common/api";
import { ActivatedRoute, Router } from "@angular/router";
import { AppSettings } from "../../../shared/AppSettings";
import { ThrowStmt } from "@angular/compiler";
import { InvoiceFilePreviewComponent } from "../../invoice-file-preview/invoice-file-preview.component";
import { UserService } from "../../../shared/user.service";

import { HttpClient } from "@angular/common/http";
import { User } from "../../../shared/user.model";

@Component({
  selector: "app-customer-invoice-details",
  templateUrl: "./customer-invoice-details.component.html",
  styleUrls: ["./customer-invoice-details.component.css"],
})
export class CustomerInvoiceDetailsComponent implements OnInit {
  @ViewChild(InvoiceFilePreviewComponent)
  filePreview: InvoiceFilePreviewComponent;

  readonly rootUrl = AppSettings.webApiURL;

  @Input() initInvoiceId: number = null;
  initInvoiceIdEncrypted: string = null;

  userDetails: any;

  invoiceDetails: any;
  orderIdLink: any = null;
  orderId?: number = null;
  showInvoicePreviewDialog: boolean = false;

  showConfirmDialog: boolean = false;
  showRejectDialog: boolean = false;
  showRedirectDialog: boolean = false;

  nextConfirmerSeleted: any;
  nextConfirmerNotes: any;

  colsSigns = [
    { field: "Step", header: "סידורי", width: "80", priority: "ui-p-6" },
    {
      field: "SignUserFullName",
      header: "חותם",
      width: "120",
      priority: "ui-p-1",
    },
    { field: "Decision", header: "החלטה", width: "50", priority: "ui-p-1" },
    { field: "SignDate", header: "תאריך", width: "80", priority: "ui-p-2" },
    {
      field: "ForwarderToUserFullName",
      header: "הועבר אל",
      width: "120",
      priority: "ui-p-6",
    },
    { field: "Notes", header: "הערות", width: "200", priority: "ui-p-6" },
  ];
  decisionClass = [
    "decision-empty",
    "decision-confirm",
    "decision-reject",
    "decision-redirectTreatment",
  ];

  validationMessage: any;
  validationMessages: any[];
  msgs: Message[] = [];

  constructor(
    private orderService: OrderService,
    private invoiceService: InvoiceService,
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient
  ) {}

  ngOnInit() {
    this.userService.getUserClaims().subscribe(
      (data: any) => {
        this.userDetails = data;
        console.log(this.userDetails);
      },
      (err: HttpErrorResponse) => {
        this.userDetails = null;
      }
    );

    if (!this.initInvoiceId) {
      this.initInvoiceIdEncrypted = this.route.snapshot.queryParamMap.get("o");
    }
    this.getInvoiceDetails();
  }

  orderDetailsCreated(event) {
    //
  }

  getInvoiceDetails() {
    let invoiceId = this.initInvoiceIdEncrypted; //this.route.snapshot.queryParamMap.get('o');
    let invoiceFilterByInvoiceIdEncoded = {
      InvoiceId: this.initInvoiceId,
      InvoiceIdLink: invoiceId,
    };
    this.invoiceService
      .getCustomerInvoiceDetails(invoiceFilterByInvoiceIdEncoded)
      .subscribe(
        (result: any) => {
          // debugger;
          this.invoiceDetails = result;
          if (this.invoiceDetails) {
            this.orderId = this.invoiceDetails.OrderId;
          }
        },
        (err: HttpErrorResponse) => {
          let errMessage =
            err.error && err.error.ExceptionMessage
              ? err.error.ExceptionMessage
              : "תקלה בקבלת נתונים ";
          this.showMessage("error", "", errMessage);
        }
      );
  }

  showFile() {
    this.showInvoicePreviewDialog = true;
    //this.filePreview.getInvoiceFile();
  }

  CustomerConfirm() {
    this.showConfirmDialog = true;
  }

  Reject() {
    this.showRejectDialog = true;
  }

  RedirectToOtherConfirmer() {
    this.showRedirectDialog = true;
  }

  Confirm1() {
    if (!this.nextConfirmerSeleted) {
      this.showMessage("error", "", "חובה לבחור גורם מטפל הבא");
      return;
    }

    let confirmData = {
      InvoiceId: this.invoiceDetails.InvoiceId,
      NextConfirmer: this.nextConfirmerSeleted,
      Notes: this.nextConfirmerNotes,
    };

    this.invoiceService.confirm1(confirmData).subscribe(
      (result: any) => {
        this.showMessage("success", "", "פעולה בוצעה בהצלחה");
        this.showConfirmDialog = false;
        this.nextConfirmerSeleted = null;
        this.nextConfirmerNotes = null;
        this.getInvoiceDetails();
      },
      (err: HttpErrorResponse) => {
        let errMessage =
          err.error && err.error.ExceptionMessage
            ? err.error.ExceptionMessage
            : "תקלה בפעולת חתימה";
        this.showMessage("error", "", errMessage);
      }
    );
  }

  Confirm2() {
    if (!this.nextConfirmerSeleted) {
      this.showMessage("error", "", "חובה לבחור גורם מטפל הבא");
      return;
    }

    let confirmData = {
      InvoiceId: this.invoiceDetails.InvoiceId,
      NextConfirmer: this.nextConfirmerSeleted,
      Notes: this.nextConfirmerNotes,
    };

    this.invoiceService.confirm2(confirmData).subscribe(
      (result: any) => {
        this.showMessage("success", "", "פעולה בוצעה בהצלחה");
        this.showConfirmDialog = false;
        this.nextConfirmerSeleted = null;
        this.nextConfirmerNotes = null;
        this.getInvoiceDetails();
      },
      (err: HttpErrorResponse) => {
        let errMessage =
          err.error && err.error.ExceptionMessage
            ? err.error.ExceptionMessage
            : "תקלה בפעולת חתימה";
        this.showMessage("error", "", errMessage);
      }
    );
  }

  Confirm21() {
    if (!this.nextConfirmerSeleted) {
      this.showMessage("error", "", "חובה לבחור גורם מטפל הבא");
      return;
    }

    let confirmData = {
      InvoiceId: this.invoiceDetails.InvoiceId,
      NextConfirmer: this.nextConfirmerSeleted,
      Notes: this.nextConfirmerNotes,
    };

    this.invoiceService.confirm21(confirmData).subscribe(
      (result: any) => {
        this.showMessage("success", "", "פעולה בוצעה בהצלחה");
        this.showConfirmDialog = false;
        this.nextConfirmerSeleted = null;
        this.nextConfirmerNotes = null;
        this.getInvoiceDetails();
      },
      (err: HttpErrorResponse) => {
        let errMessage =
          err.error && err.error.ExceptionMessage
            ? err.error.ExceptionMessage
            : "תקלה בפעולת חתימה";
        this.showMessage("error", "", errMessage);
      }
    );
  }

  Confirm3() {
    if (this.nextConfirmerSeleted) {
      this.showMessage(
        "error",
        "",
        "לא ניתן לבחור גורם מטפל הבא בביצוע פעולה זאת"
      );
      return;
    }

    let confirmData = {
      InvoiceId: this.invoiceDetails.InvoiceId,
      NextConfirmer: this.nextConfirmerSeleted,
      Notes: this.nextConfirmerNotes,
    };

    this.invoiceService.confirm3(confirmData).subscribe(
      (result: any) => {
        this.showMessage("success", "", "פעולה בוצעה בהצלחה");
        this.showConfirmDialog = false;
        this.nextConfirmerSeleted = null;
        this.nextConfirmerNotes = null;
        this.getInvoiceDetails();
      },
      (err: HttpErrorResponse) => {
        let errMessage =
          err.error && err.error.ExceptionMessage
            ? err.error.ExceptionMessage
            : "תקלה בפעולת חתימה";
        this.showMessage("error", "", errMessage);
      }
    );
  }

  Reject1() {
    if (!this.nextConfirmerSeleted) {
      this.showMessage("error", "", "חובה לבחור גורם מטפל הבא");
      return;
    }

    let confirmData = {
      InvoiceId: this.invoiceDetails.InvoiceId,
      NextConfirmer: this.nextConfirmerSeleted,
      Notes: this.nextConfirmerNotes,
    };

    this.invoiceService.reject1(confirmData).subscribe(
      (result: any) => {
        this.showMessage("success", "", "פעולה בוצעה בהצלחה");
        this.showRejectDialog = false;
        this.nextConfirmerSeleted = null;
        this.nextConfirmerNotes = null;
        this.getInvoiceDetails();
      },
      (err: HttpErrorResponse) => {
        let errMessage =
          err.error && err.error.ExceptionMessage
            ? err.error.ExceptionMessage
            : "תקלה בפעולת חתימה";
        this.showMessage("error", "", errMessage);
      }
    );
  }

  Reject2() {
    if (!this.nextConfirmerSeleted) {
      this.showMessage("error", "", "חובה לבחור גורם מטפל הבא");
      return;
    }

    let confirmData = {
      InvoiceId: this.invoiceDetails.InvoiceId,
      NextConfirmer: this.nextConfirmerSeleted,
      Notes: this.nextConfirmerNotes,
    };

    this.invoiceService.reject2(confirmData).subscribe(
      (result: any) => {
        this.showMessage("success", "", "פעולה בוצעה בהצלחה");
        this.showRejectDialog = false;
        this.nextConfirmerSeleted = null;
        this.nextConfirmerNotes = null;
        this.getInvoiceDetails();
      },
      (err: HttpErrorResponse) => {
        let errMessage =
          err.error && err.error.ExceptionMessage
            ? err.error.ExceptionMessage
            : "תקלה בפעולת חתימה";
        this.showMessage("error", "", errMessage);
      }
    );
  }

  Reject3() {
    if (this.nextConfirmerSeleted) {
      this.showMessage(
        "error",
        "",
        "לא ניתן לבחור גורם מטפל הבא בביצוע פעולה זאת"
      );
      return;
    }

    let confirmData = {
      InvoiceId: this.invoiceDetails.InvoiceId,
      NextConfirmer: this.nextConfirmerSeleted,
      Notes: this.nextConfirmerNotes,
    };

    this.invoiceService.reject3(confirmData).subscribe(
      (result: any) => {
        this.showMessage("success", "", "פעולה בוצעה בהצלחה");
        this.showRejectDialog = false;
        this.nextConfirmerSeleted = null;
        this.nextConfirmerNotes = null;
        this.getInvoiceDetails();
      },
      (err: HttpErrorResponse) => {
        let errMessage =
          err.error && err.error.ExceptionMessage
            ? err.error.ExceptionMessage
            : "תקלה בפעולת חתימה";
        this.showMessage("error", "", errMessage);
      }
    );
  }

  RejectReturnToSupplier() {
    if (this.nextConfirmerSeleted) {
      this.showMessage(
        "error",
        "",
        "לא ניתן לבחור גורם מטפל הבא בביצוע פעולה זאת"
      );
      return;
    }

    let confirmData = {
      InvoiceId: this.invoiceDetails.InvoiceId,
      NextConfirmer: this.nextConfirmerSeleted,
      Notes: this.nextConfirmerNotes,
    };

    this.invoiceService.RejectReturnToSupplier(confirmData).subscribe(
      (result: any) => {
        this.showMessage("success", "", "פעולה בוצעה בהצלחה");
        this.showRejectDialog = false;
        this.nextConfirmerSeleted = null;
        this.nextConfirmerNotes = null;
        this.getInvoiceDetails();
      },
      (err: HttpErrorResponse) => {
        let errMessage =
          err.error && err.error.ExceptionMessage
            ? err.error.ExceptionMessage
            : "תקלה בביצוע הפעולה";
        this.showMessage("error", "", errMessage);
      }
    );
  }

  Redirect() {
    if (!this.nextConfirmerSeleted) {
      this.showMessage("error", "", "חובה לבחור גורם מטפל הבא");
      return;
    }

    let confirmData = {
      InvoiceId: this.invoiceDetails.InvoiceId,
      NextConfirmer: this.nextConfirmerSeleted,
      Notes: this.nextConfirmerNotes,
    };

    this.invoiceService.redirect(confirmData).subscribe(
      (result: any) => {
        this.showMessage("success", "", "פעולה בוצעה בהצלחה");
        this.showRedirectDialog = false;
        this.nextConfirmerSeleted = null;
        this.nextConfirmerNotes = null;
        this.getInvoiceDetails();
      },
      (err: HttpErrorResponse) => {
        let errMessage =
          err.error && err.error.ExceptionMessage
            ? err.error.ExceptionMessage
            : "תקלה בפעולת חתימה";
        this.showMessage("error", "", errMessage);
      }
    );
  }

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({
      severity: type,
      summary: summaryMessage,
      detail: message,
    });
  }

  showSuccess() {
    this.msgs = [];
    this.msgs.push({
      severity: "success",
      summary: "",
      detail: " העדכון נשמר בהצלחה",
    });
  }

  showError() {
    this.msgs = [];
    this.msgs.push({ severity: "error", summary: "", detail: " שגיאה בעדכון" });
  }

  whoAreYou = () => {
    this.http
      .get("http://localhost:35678/api/Account/WhoAreYou123")
      .subscribe((response) => {
        console.log(response);
      });
  };

  dontShowMySelf = () => {
    this.userService.getUserClaims().subscribe((data: any) => {
      this.userDetails = data;
      console.log(this.userDetails);
      let newUser: User;
      newUser = data;
      console.log("this is the email of loged user - ", newUser.UserName);
      console.log(this.invoiceDetails.wfConfirmers);
    });
  };

  dontShowIfItsMe = () => {
    // console.log(this.userService.getUserClaims());

    this.userService.getUserClaims().subscribe((data: any) => {
      console.log(data.UserName);
      let newUserName = data.UserName;
      const userId = data.Id;
      const item = this.invoiceDetails.wfConfirmers.filter(
        (x) => x.value == userId
      );
      console.log(item);
      const idx = this.invoiceDetails.wfConfirmers.indexOf(item);
      this.invoiceDetails.wfConfirmers.splice(idx, 1);
      console.log(this.invoiceDetails.wfConfirmers);
      console.log(this.invoiceDetails.wfConfirmers);
    });
  };

  showSomethingElse = () => {
    this.userService.getUserClaims().subscribe((response: any) => {
      console.log(response);
      console.log(response.UserName);
    });
  };
}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/invoice/customer-invoice/customer-invoice-details/customer-invoice-details.component.ts